import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "mt-20 mb-2 flex justify-center" }
const _hoisted_2 = { class: "w-8" }
const _hoisted_3 = {
  key: 0,
  class: "mb-28 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "My action plan for this challenge is...", -1)
const _hoisted_5 = {
  key: 2,
  class: "text-cebai-grey-dark font-robotoRegular"
}
const _hoisted_6 = { class: "text-cebai-primary p-0.5 border-2 border-cebai-grey-light rounded-full hover:bg-cebai-grey-lightest transition" }
const _hoisted_7 = {
  key: 0,
  class: "p-4 border-2 border-cebai-grey-light rounded-md mb-6"
}
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "block text-lg font-robotoBold mb-2" }, " How confident are you that your plan will work? ", -1)
const _hoisted_10 = { class: "text-base mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Your level of confidence: ", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "mb-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block text-lg font-robotoBold mb-2" }, " What would help you achieve your outcome? ", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block text-lg font-robotoBold mb-2" }, " What would stop you from achieving your outcome? ", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mb-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "block text-lg font-robotoBold mb-2" }, " How will I know if it worked? ", -1)
const _hoisted_22 = { class: "mb-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "block text-lg font-robotoBold mb-2" }, " I will implement this plan by... ", -1)
const _hoisted_24 = ["value", "disabled"]
const _hoisted_25 = { class: "mt-12 flex justify-between" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Download plan ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Download ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Delete plan ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Delete ", -1)
const _hoisted_31 = { class: "flex justify-end items-center py-3" }
const _hoisted_32 = {
  key: 0,
  class: "text-base text-cebai-grey-dark leading-snug pr-2 mr-auto"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to delete this plan? This can't be undone.", -1)
const _hoisted_34 = {
  key: 0,
  class: "text-cebai-grey-dark"
}
const _hoisted_35 = { class: "flex justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChallengeNavigation = _resolveComponent("ChallengeNavigation")!
  const _component_ChallengeHeader = _resolveComponent("ChallengeHeader")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AutoResizeTextarea = _resolveComponent("AutoResizeTextarea")!
  const _component_ArrowUpIcon = _resolveComponent("ArrowUpIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DateSelect = _resolveComponent("DateSelect")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BinIcon = _resolveComponent("BinIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_Ribbon = _resolveComponent("Ribbon")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Download = _resolveComponent("Download")!
  const _component_GuidedTour = _resolveComponent("GuidedTour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_ChallengeNavigation),
        _createVNode(_component_ChallengeHeader, { "is-editable": false })
      ]),
      _: 1
    }),
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        (_ctx.isLoadingPlan || _ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_LoadingIcon)
                ])
              ]),
              (_ctx.isLoadingPlan)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Generating the plan. It takes a little time... "))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_Editorial, { class: "w-full sm:w-auto mt-12" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_AutoResizeTextarea, {
                id: "input-plan",
                ref: "inputPlanTextEl",
                modelValue: _ctx.inputPlanText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputPlanText) = $event)),
                readonly: _ctx.challengeIsResolved,
                rows: 10,
                "max-rows": 20,
                class: "input",
                placeholder: "Add your plan here"
              }, null, 8, ["modelValue", "readonly"]),
              _createElementVNode("button", {
                class: "flex items-center text-left w-full sm:w-auto mt-6",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDetails && _ctx.toggleDetails(...args)))
              }, [
                _createVNode(_component_Editorial, { class: "w-full sm:w-auto mr-4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, [
                      (_ctx.challengeIsResolved)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("View")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Add")
                          ], 64)),
                      _createTextVNode(" more details "),
                      (!_ctx.challengeIsResolved)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (optional) "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ArrowUpIcon, {
                    class: _normalizeClass(["w-8 h-8 fill-current transition", { 'transform rotate-180': !_ctx.showDetails }])
                  }, null, 8, ["class"])
                ])
              ]),
              (_ctx.showDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("p", _hoisted_10, [
                        _hoisted_11,
                        (_ctx.inputConfidenceLevel !== -1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.inputConfidenceLevel) + "% ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputConfidenceLevel) = $event)),
                          type: "range",
                          class: "w-full",
                          disabled: _ctx.challengeIsResolved
                        }, null, 8, _hoisted_13), [
                          [_vModelText, _ctx.inputConfidenceLevel]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      (_ctx.challengeIsActive)
                        ? (_openBlock(), _createBlock(_component_Multiselect, {
                            key: 0,
                            modelValue: _ctx.inputHelpsOutcome,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputHelpsOutcome) = $event)),
                            mode: "tags",
                            "no-options-text": "Add new tags and press enter",
                            "no-results-text": "Add new tags and press enter",
                            placeholder: "Select or add your own...",
                            options: _ctx.helpsOutcomeOptions,
                            "close-on-select": false,
                            searchable: true,
                            "create-option": true,
                            "can-clear": false,
                            "break-tags": true
                          }, null, 8, ["modelValue", "options"]))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputHelpsOutcome, (outcome, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "inline-block px-2 py-0.5 text-sm bg-cebai-grey-light rounded-md mr-2 font-robotoBold"
                              }, _toDisplayString(outcome), 1))
                            }), 128))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      (_ctx.challengeIsActive)
                        ? (_openBlock(), _createBlock(_component_Multiselect, {
                            key: 0,
                            modelValue: _ctx.inputPreventsOutcome,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputPreventsOutcome) = $event)),
                            mode: "tags",
                            "no-options-text": "Add new tags and press enter",
                            "no-results-text": "Add new tags and press enter",
                            placeholder: "Select or add your own...",
                            options: _ctx.preventsOutcomeOptions,
                            "close-on-select": false,
                            searchable: true,
                            "create-option": true,
                            "can-clear": false,
                            "break-tags": true
                          }, null, 8, ["modelValue", "options"]))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputPreventsOutcome, (outcome, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "inline-block px-2 py-0.5 text-sm bg-cebai-grey-light rounded-md mr-2 font-robotoBold"
                              }, _toDisplayString(outcome), 1))
                            }), 128))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_AutoResizeTextarea, {
                        modelValue: _ctx.inputSuccessCriteria,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputSuccessCriteria) = $event)),
                        disabled: _ctx.challengeIsResolved,
                        rows: 2,
                        "max-rows": 10,
                        class: "input"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      (_ctx.challengeIsActive)
                        ? (_openBlock(), _createBlock(_component_DateSelect, {
                            key: 0,
                            modelValue: _ctx.inputTargetDate,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputTargetDate) = $event)),
                            placeholder: "Set a due date...",
                            "target-date": _ctx.inputTargetDate,
                            class: "input w-full"
                          }, null, 8, ["modelValue", "target-date"]))
                        : _createCommentVNode("", true),
                      (_ctx.challengeIsResolved)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 1,
                            value: _ctx.formattedTargetDate,
                            disabled: _ctx.challengeIsResolved,
                            readonly: true,
                            type: "text",
                            class: "input w-full"
                          }, null, 8, _hoisted_24))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_AppButton, {
                    class: "mr-2",
                    type: "secondary",
                    disabled: !_ctx.hasInitialDetails,
                    onClick: _ctx.showDownloadPlanModal
                  }, {
                    iconBefore: _withCtx(() => [
                      _createVNode(_component_DownloadIcon, { class: "stroke-current stroke-[1.5px] mr-1 sm:mr-2" })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_27,
                      _hoisted_28
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  (!_ctx.challengeIsResolved)
                    ? (_openBlock(), _createBlock(_component_AppButton, {
                        key: 0,
                        class: "mr-2",
                        type: "danger",
                        onClick: _ctx.showDeletePlanModal
                      }, {
                        iconBefore: _withCtx(() => [
                          _createVNode(_component_BinIcon, { class: "fill-current mr-1 sm:mr-2" })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_29,
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (!_ctx.challengeIsResolved)
                    ? (_openBlock(), _createBlock(_component_AppButton, {
                        key: 0,
                        disabled: _ctx.hasInitialDetails,
                        type: "primary",
                        onClick: _ctx.handleUpdate
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Update ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Ribbon, {
      class: "mt-16",
      "ribbon-type": "primary"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          (!_ctx.hasInitialDetails)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Save changes before creating resolution "))
            : _createCommentVNode("", true),
          _createVNode(_component_AppButtonRouterLink, {
            id: "button-resolution",
            class: "whitespace-nowrap",
            type: "primary",
            disabled: !_ctx.hasInitialDetails,
            to: { name: 'challenge-saved-resolution' }
          }, {
            iconAfter: _withCtx(() => [
              _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
            ]),
            default: _withCtx(() => [
              (_ctx.challengeIsResolved || _ctx.hasResolution)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("View")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Create")
                  ], 64)),
              _createTextVNode(" resolution ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.deletePlan,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isShown.deletePlan) = $event)),
      close: () => _ctx.closeModal('deletePlan')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('deletePlan'),
          title: "Delete plan",
          class: "md:max-w-xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_33,
                (_ctx.hasResolution)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_34, " (Your resolution for this plan will also be deleted.) "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_AppButton, {
                    class: "mr-2",
                    type: "secondary",
                    onClick: _cache[7] || (_cache[7] = () => _ctx.closeModal('deletePlan'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppButton, {
                    type: "danger",
                    onClick: _ctx.handleDeletePlan
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Delete")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.downloadPlan,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isShown.downloadPlan) = $event)),
      close: () => _ctx.closeModal('downloadPlan')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('downloadPlan'),
          title: "Download plan"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Download, {
              ideas: _ctx.solutionIdeas,
              "output-type": "plan",
              "close-modal": () => _ctx.closeModal('downloadPlan')
            }, {
              title: _withCtx(() => [
                _createTextVNode(" How would you like to download your plan? ")
              ]),
              _: 1
            }, 8, ["ideas", "close-modal"])
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"]),
    _createVNode(_component_GuidedTour, { name: "challenge-plan" })
  ], 64))
}